import React from 'react'

const Inclusivity = () => {
  return (
    <div>Inclusivity</div>
  )
}

export default Inclusivity